
import { defineComponent, ref } from "vue"
import { spatialOmicsApi } from "@/request";
import GeneAttributeViewPlot from "@/components/GeneAttributeViewPlot.vue"

export default defineComponent({
  components: {
    GeneAttributeViewPlot
  },
  setup() {
    let selectedGeneFeature = ref('')
    let geneFeatureList = ref([])
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    let geneFeatureAllList = []
    let markerSize = ref(2)
    let markerSizeList = ref([1,2,3,4,5,6,7,8,9,10])
    let selectCellNames = ref([])
    let cellNameList = ref([])
    let dataId = -1
    const attributePlot: any = ref(null)

    /**
     * 获取当前的data id
     */
    const getDataId = () => {
      return dataId
    }

    /**
     * 设置数据
     * @param data data数据
     */
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const setData = (data) => {
      dataId = data.id
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      geneFeatureList.value = data['feature_list']['obs'].map((value: string) => ({
        value: value,
        label: value,
      }))
      selectedGeneFeature.value = data['feature_list']['obs'][0]
      for(let i=0;i<data['feature_list']['obs'].length;i++){
        if("leiden" === data['feature_list']['obs'][i]){
          console.log("change", data['feature_list']['obs'][i])
          selectedGeneFeature.value = data['feature_list']['obs'][i]
        }
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      geneFeatureAllList = data['feature_list']['obs'].map((value: string) => ({
        value: value,
        label: value,
      }))
    }

    /**
     * 基因选项的filter函数
     * @param query 查询字符串
     */
    const geneFeatureFilter = (query: string) => {
      console.log(query)
      if (query !== '') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        geneFeatureList.value = geneFeatureAllList.filter((item: any) => {
          return item.label.toLowerCase().includes(query.toLowerCase())
        })
      } else {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        geneFeatureList.value = geneFeatureAllList
      }
    }

    /**
     * 根据选择的基因获取当前基因的Attribute相关数据，并更新相关的图
     */
    const getGeneAttributeViewData = () => {
      let geneInfo = {
        'data_id': dataId,
        'attribute_name': selectedGeneFeature.value,
      }
      console.log(geneInfo)
      spatialOmicsApi.getGeneAttributeView(geneInfo).then(async (res) => {
        console.log(res.data)
        cellNameList.value = res.data['gene_statistics']
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        selectCellNames.value = cellNameList.value.map((item: any) => {
          return item['cell_name']
        })
        attributePlot.value.setPlotData(res.data)
      })
    }

    /**
     * 散点图点大小改变的回调函数
     */
    const markerSizeChangeCallback = () => {
      console.log(markerSize)
      attributePlot.value.changeMarkerSize(markerSize.value)
    }

    /**
     * 选择cell name的回调函数
     */
    const selectChangeCallback = () => {
      attributePlot.value.selectByCellNames(selectCellNames.value)
    }

    return {
      selectedGeneFeature,
      geneFeatureList,
      markerSize,
      markerSizeList,
      selectCellNames,
      cellNameList,
      attributePlot,
      getDataId,
      setData,
      getGeneAttributeViewData,
      markerSizeChangeCallback,
      selectChangeCallback,
      geneFeatureFilter,
    }
  }
})

